import { tlwTwMerge, type GenerateCvaType } from '@trg/utils';
import { cva } from 'class-variance-authority';
import type { HTMLAttributes } from 'react';
import { Icon, type IconName } from '../icon';

export type TagProps = HTMLAttributes<HTMLSpanElement> & {
  type?: 'gray' | 'dark' | 'orange';
  icon?: IconName | null;
};

type TagVariantsType = GenerateCvaType<TagProps, 'type'>;

const tagVariantsGenerator = cva<TagVariantsType>(
  'tlw-txt-zh-mini tlw-px-1 tlw-py-0.5 tlw-flex tlw-items-center tlw-gap-0.5 tlw-rounded-sm tlw-overflow-hidden lg:tlw-px-2 lg:tlw-py-1 lg:tlw-gap-1 lg:tlw-rounded',
  {
    variants: {
      type: {
        gray: ['tlw-text-txt-800 tlw-bg-gray-200'],
        dark: ['tlw-text-txt-white tlw-bg-gray-700'],
        orange: ['tlw-text-txt-white tlw-bg-pr-medium'],
      },
    },
  }
);

export function Tag({
  type = 'gray',
  icon,
  className,
  children,
  ...props
}: TagProps) {
  return (
    <span
      className={tlwTwMerge(tagVariantsGenerator({ type }), className)}
      {...props}
    >
      {icon && <Icon name={icon} size={16} />}

      {children}
    </span>
  );
}
